<tt-page *ngIf="!!edit">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 sp-0">
            <tt-tabs [(ttSelectedId)]="selectedBgEdiExportMain">
                <tt-tab ttId="DETAILS" ttLabel="gb_ediexport_main_details"></tt-tab>
                <tt-tab ttId="CONTENT" ttLabel="gb_ediexport_main_content"></tt-tab>
                <tt-tab ttId="FUNCTIONS" ttLabel="gb_ediexport_main_functions"></tt-tab>
            </tt-tabs>

            <div [hidden]="selectedBgEdiExportMain !== 'DETAILS'">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </div>

            <tt-textarea [hidden]="selectedBgEdiExportMain !== 'CONTENT'" ttLabel="filecontent" [(ttModel)]="edit.filecontent"></tt-textarea>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="ediexport_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_ediexport_main_details">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_ediexport_main_content">
                        <tt-textarea ttLabel="filecontent" [(ttModel)]="edit.filecontent"></tt-textarea>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_ediexport_main_functions">

                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="edi_export_keyno" [ttModel]="edit.edi_export_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="reg_datetime" [ttModel]="edit.reg_datetime" ttReadonly></tt-input>
        <tt-select ttLabel="edi_destination_name" [(ttModel)]="edit.edi_destination_keyno" [ttData]="selectListEdiDestinations" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-input ttLabel="filename" [(ttModel)]="edit.filename"></tt-input>
        <tt-input ttLabel="edi_process_status_name" [ttModel]="edit.edi_process_status_name" ttReadonly></tt-input>
        <tt-input ttLabel="processing_message" [ttModel]="edit.processing_message" ttReadonly></tt-input>
        <tt-select ttLabel="p2_exportproc_name" [(ttModel)]="edit.p2_exportproc_keyno" [ttData]="selectListExportProcedures" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="edit.reg_by_portal_user_name" ttReadonly></tt-input>
        <tt-input ttLabel="processing_create_start_datetime" [ttModel]="edit.processing_create_start_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="processing_create_end_datetime" [ttModel]="edit.processing_create_end_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="processing_create_count" [ttModel]="edit.processing_create_count" ttReadonly></tt-input>
        <tt-input ttLabel="add_type" [ttModel]="edit.add_type" ttReadonly></tt-input>
        <tt-input ttLabel="processing_create_millisec" [ttModel]="edit.processing_create_millisec" ttReadonly></tt-input>
        <tt-input ttLabel="delivery_start_datetime" [ttModel]="edit.delivery_start_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="delivery_end_datetime" [ttModel]="edit.delivery_end_datetime" ttReadonly></tt-input>
        <tt-input ttLabel="delivery_try_count" [ttModel]="edit.delivery_try_count" ttReadonly></tt-input>
    </ng-container>
</ng-template>
